import React, {createContext, useContext, useEffect, useState} from 'react'
import axios from 'axios'

interface SessionUser {
    id: string
    username: string
    display_name?: string
    email: string
    authorized: boolean
    timezone?: string
    roles: Array<{role: string}>
}

interface SessionContextValue {
    user: SessionUser | null
    authenticated: boolean
    authorized: boolean
    roles: string[]
    loading: boolean
}

const SessionContext = createContext<SessionContextValue>({
    user: null,
    authenticated: false,
    authorized: false,
    roles: [],
    loading: true,
})

export function SessionProvider({children}: {children: React.ReactNode}) {
    const [user, setUser] = useState<SessionUser | null>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        axios.get('/auth/current-session')
            .then(({data}) => {
                if (data?.user) setUser(data.user)
            })
            .catch(() => {})
            .finally(() => setLoading(false))
    }, [])

    const authenticated = user !== null
    const authorized = user?.authorized ?? false
    const roles = (user?.roles ?? []).map(r => r.role)

    return (
        <SessionContext.Provider value={{user, authenticated, authorized, roles, loading}}>
            {children}
        </SessionContext.Provider>
    )
}

export function useSession(): SessionContextValue {
    return useContext(SessionContext)
}
